import { Badge } from "react-bootstrap";
import { Link } from "@tanstack/react-router";
import { useDates } from "../../dates/DatesContext";
import { generateUrl } from "../../dates/utils";
import useDashboardTheme from "../../hooks/useDashboardTheme";
import { linkOptionsFromHref } from "../../utils/searchParams";

const SidebarLink = ({
  icon,
  children,
  isActive,
  to,
  small = false,
  section = "main",
  primarySidebarLink = false,
  isVisible = true,
  badge = null,
}) => {
  const dates = useDates();
  const url = generateUrl(to, dates);

  const { sidebarColor } = useDashboardTheme();
  const highlightLink = isActive.trim() && primarySidebarLink;

  if (!isVisible) {
    return null;
  }

  return (
    <li
      className={`${isActive} ${highlightLink ? "highlight" : ""}`}
      style={{
        width: "100%",
        borderRadius: "5px",
        marginBottom: small ? "inherit" : "1.5rem",
      }}
    >
      <Link
        {...linkOptionsFromHref(url)}
        activeOptions={{ includeSearch: false }}
        className={`${small ? "" : "nav-link"} sidebar-nav-link ${section}-section`}
        style={{
          cursor: "pointer",
          backgroundColor: highlightLink ? sidebarColor : "inherit",
          borderBottom: isActive.trim() ? `1px solid ${sidebarColor}` : "",
          borderRadius: highlightLink ? "5px" : 0,
          ...(small ? {} : { marginBottom: ".5rem" }),
        }}
      >
        {small ?
          <>
            <span className="sidebar-mini text-start ps-1">{icon}</span>
            <span className="sidebar-normal sidebar-link">
              {children}
              {badge && (
                <Badge
                  className={`badge-${isActive.trim() ? "secondary" : "primary"}`}
                  style={{ marginLeft: "0.5rem", fontSize: "9px" }}
                  pill
                >
                  {badge}
                </Badge>
              )}
            </span>
          </>
        : <>
            {icon}
            <p
              style={{
                color: highlightLink ? "#FFF" : "#2e0054",
              }}
            >
              {children}
              {badge && (
                <Badge
                  className={`badge-${isActive.trim() ? "secondary" : "primary"}`}
                  style={{ marginLeft: "0.5rem", fontSize: "9px" }}
                  pill
                >
                  {badge}
                </Badge>
              )}
            </p>
          </>
        }{" "}
      </Link>
    </li>
  );
};

export default SidebarLink;
